export default __webpack_public_path__ + "static/media/PTS-logo-white.b015eb5a.png";